// Module
var code = "<div class=\"dms-usergridconfig\">\n</div>";
// Exports
export default code;